const TERMS_OF_USE = {
    SERVICE_AGREEMENT: 0,
    PRIVATE_POLICY: 1,
    LOCATION_AGREEMENT: 2,
};

export {TERMS_OF_USE}